<template>
  <div>
    <div class="flex gap-2 items-center relative">
      <div class="dot" />
      <AppIcon :name="connector.type" />
      <span
        class="address"
        @click="copyToClipboard(address)"
      >
        {{ cutString(address, 7, 7) }}
      </span>
    </div>
    <div class="divider" />
    <button
      class="logout"
      @click="emit('disconnect')"
    >
      <AppIcon name="logout_icon" />
      {{ getContent('wallet.logout_button') }}
    </button>
  </div>
</template>

<script setup>
import { useAccount } from '@wagmi/vue'

const { address, connector } = useAccount()
const emit = defineEmits(['disconnect'])
</script>

<style lang="scss" scoped>
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $green;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -14px;
}

.address {
  font-size: 16px;
  line-height: 24px;
  color: $white;
  cursor: pointer;
  user-select: none;
  transition: .3s ease-in-out;

  &:hover {
    color: $yellow-100;
  }
}

.divider {
  height: 1px;
  background-color: $gray-200;
  margin: 16px -32px;
}

.logout {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  transition: .3s ease-in-out;
  color: $white;
  background-color: transparent;
  border: none;
  outline: none;
  text-decoration: underline;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: $yellow-100;
  }
}
</style>